import { createFileRoute, redirect } from "@tanstack/react-router";
import { getProvider } from "@/data/heallexa";

export const Route = createFileRoute("/providers_/$id/claim")({
  loader: async ({ params }) => {
    const provider = await getProvider(params.id);
    if (!provider) throw redirect({ to: "/browse" });
    throw redirect({ to: "/claim", search: { providerId: provider.id, plan: "free" } as any });
  },
  head: () => ({ meta: [{ name: "robots", content: "noindex" }] }),
  component: () => null,
});
